import { clsx } from 'clsx';
import { Typography } from '@material-ui/core';

import { OrderTypeChip } from '../../order-type-chip';

import { formatCurrency } from '../../../utils/CurrencyUtils';
import makeClasses from './CustomActionKanbanCard.styles';

import { TurboTag } from '../../../features/order/geoqueues/components';
import { AuditableChip } from 'components/main-kanban-card/components';

export default function CustomActionKanbanCard(props) {
  const {
    onClick,
    storeName,
    orderID,
    totalPrice,
    showChipOfBundle = false,
    showAuditableChip = false,
    classes: externalClasses = {},
    isTurboqueue = false,
  } = props;

  const showStoreName = Boolean(storeName);
  const showTotalPrice = Boolean(totalPrice);

  const classes = makeClasses();

  return (
    <article
      onClick={onClick}
      data-has-turbotag={isTurboqueue}
      className={clsx(classes.article, externalClasses?.root)}
    >
      {isTurboqueue && <TurboTag parentClass={classes.turboTag} />}
      <section className={classes.section}>
        <header>
          <OrderTypeChip orderType={showChipOfBundle ? 'bundle' : 'normal'} />
          <AuditableChip show={showAuditableChip} />
        </header>
        <main>
          <Typography component='h5' variant='body1' className={classes.oId}>
            ID: {orderID}
          </Typography>
        </main>
        {(showStoreName || showTotalPrice) && (
          <footer>
            {showStoreName && (
              <Typography className={classes.storeName} variant='overline'>
                {storeName}
              </Typography>
            )}
            {showTotalPrice && (
              <Typography variant='subtitle2'>
                {formatCurrency(totalPrice, true)}
              </Typography>
            )}
          </footer>
        )}
      </section>
    </article>
  );
}
